var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSwim = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.821 10.148 5.288 4.535c-.062.034-.123.076-.184.114-.687.474-1.532.776-2.261.776-.75 0-1.559-.294-2.262-.776a2.453 2.453 0 0 0-2.815 0c-.654.45-1.452.776-2.262.776-.386 0-.806-.084-1.219-.237C8.228 10.713 12.014 7 16.667 7h2.445a1.221 1.221 0 1 1 0 2.445h-2.445a6.048 6.048 0 0 0-2.846.703zm-5.71-.703a2.445 2.445 0 1 1-4.89 0 2.445 2.445 0 0 1 4.89 0zm5.596 6.338c.86.592 1.91.997 2.96.997 1.028 0 2.117-.413 2.957-.997a1.217 1.217 0 0 1 1.498.065c.55.454 1.241.802 1.933.962a1.222 1.222 0 0 1-.554 2.38 7.271 7.271 0 0 1-2.223-.955c-1.108.596-2.35.99-3.61.99-1.22 0-2.316-.378-3.072-.722a12.542 12.542 0 0 1-.596-.294c-.172.091-.37.194-.596.294-.756.344-1.853.722-3.071.722-1.261 0-2.503-.394-3.61-.986-.513.321-1.288.738-2.224.955a1.222 1.222 0 0 1-.554-2.38 4.825 4.825 0 0 0 1.933-.962 1.228 1.228 0 0 1 1.498-.065c.844.58 1.929.993 2.957.993 1.05 0 2.1-.405 2.96-.997.424-.302.99-.302 1.414 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSwim, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-swim.438d2f85.svg";
export { ForwardRef as ReactComponent };